import React from 'react';
import {
    Box,
    HStack,
    Grid,
    Text,
    Flex,
    Button,
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

interface PiiDataViewerProps {
    piiData: { detectedText: string; category: string; page: string }[];
    isPiiConfirmed: boolean;
    togglePiiConfirmed: () => void;
    onPiiClick: (item: {
        detectedText: string;
        category: string;
        page: string;
        startOffset: string;
        length: string;
    }) => void;
}

const PiiDataViewer: React.FC<PiiDataViewerProps> = ({ piiData, isPiiConfirmed, togglePiiConfirmed, onPiiClick }) => {
    return (
        <Box mt={4}>
            <Box border="1px solid #e2e8f0" borderRadius="md" p={4} bg="#fdf6df">
                <HStack mb={2}>
                    <WarningIcon color="yellow.500" />
                    <Text fontWeight="bold">
                        This file contains the following sensitive data:
                    </Text>
                </HStack>
                <Box height="300px" overflowY="auto">
                    {piiData.map((item, index) => (
                        <Grid
                            key={index}
                            templateColumns="3fr 1fr 1fr"
                            gap={4}
                            mt={2}
                            borderBottom={index < piiData.length - 1 ? "1px solid #e2e8f0" : undefined}
                            pb={2}
                        >
                            <Text
                                isTruncated
                                maxWidth="100%"
                                color="blue.500"
                                cursor="pointer"
                                _hover={{ textDecoration: 'underline' }}
                                onClick={() => onPiiClick(item as any)}
                            >
                                {item.detectedText}
                            </Text>
                            <Text isTruncated maxWidth="100%">{item.category}</Text>
                            <Text isTruncated maxWidth="100%">{item.page}</Text>
                        </Grid>
                    ))}
                </Box>
                <Flex justifyContent="flex-end" mt={4}>
                    <Button
                        colorScheme={isPiiConfirmed ? "red" : "green"}
                        variant={isPiiConfirmed ? "cancel" : "brand"}
                        onClick={togglePiiConfirmed}
                    >
                        {isPiiConfirmed ? "Not Confirm" : "Confirm"}
                    </Button>
                </Flex>
            </Box>
        </Box>
    );
};

export default PiiDataViewer;
